/**
 * Initializes an Alpine.js data object to manage quick add-to-cart actions directly from product cards.
 * Key features include:
 * 1. Automatic Cart Addition: Automatically adds a product to the cart if only one variant is available and it's for sale.
 * 2. Variant Handling: Processes and adds selected variants to the cart upon user interaction.
 * 3. UI Cleanup: Hides the quick add interface and cleans up UI elements post-action.
 */

const productCardQuickAdd = () => ({
  async init() {
    if (this.shopifyData.variants.length === 1 && this.shopifyData.variants[0].availableForSale) {
      this.$root.style.display = 'none';
      try {
        await this.addToCart();
      } catch (e) {
        //
      }
      this.close();
    }
  },

  close() {
    this.quickAddOpen = false;
  },

  async handleVariantClick(variant) {
    this.normalizeOptionsAndVariants(variant.selectedOptions.map((option) => [option.name, option.value]));
    await this.addToCart();
    this.close();
  },
});

document.addEventListener('alpine:init', () => {
  Alpine.data('productCardQuickAdd', productCardQuickAdd);
});
